


export const PlayStore = 'https://play.google.com/store/apps/details?id=be.uliege.ugo.mobile.android';
export const AppStore = 'https://apps.apple.com/be/app/ugo/id1464882179?l=fr';
